import { render, staticRenderFns } from "./AssetDetailsModel.vue?vue&type=template&id=542a3d38&scoped=true&"
import script from "./AssetDetailsModel.vue?vue&type=script&lang=js&"
export * from "./AssetDetailsModel.vue?vue&type=script&lang=js&"
import style0 from "./AssetDetailsModel.vue?vue&type=style&index=0&id=542a3d38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542a3d38",
  null
  
)

export default component.exports